import styled from 'styled-components';

const StyledShell = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  background: ${({ theme }) => theme.colors.surface};
`;

const StyledMain = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  overflow-y: auto;
`;

const StyledContent = styled.div`
  width: 100%;
  max-width: 680px;
`;

const StyledHeaderBlock = styled.div`
  margin-bottom: 2rem;
`;

const StyledTitle = styled.h1`
  margin: 0 0 0.375rem;
`;

const StyledSubtitle = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colors.textSecondary};
  font-size: 15px;
`;

const StyledCard = styled.div`
  background: ${({ theme }) => theme.colors.panel};
  border: 1px solid ${({ theme }) => theme.colors.borderSubtle};
  border-radius: ${({ theme }) => theme.radii.lg};
  box-shadow: ${({ theme }) => theme.shadows.paletteHover};
  overflow: hidden;
`;

const StyledCardSection = styled.div`
  padding: 1.75rem 2rem;
`;

const StyledCardSectionWithDivider = styled(StyledCardSection)`
  border-bottom: 1px solid ${({ theme }) => theme.colors.borderSubtle};
`;

const StyledSectionTitle = styled.h3`
  margin: 0 0 1rem;
`;

const StyledActiveEnvInfo = styled.p`
  font-size: 13px;
  color: ${({ theme }) => theme.colors.textSecondary};
  margin: 0 0 1.25rem;
  line-height: 1.6;
`;

const StyledActiveEnvName = styled.strong`
  color: ${({ theme }) => theme.colors.primary};
`;

const StyledActiveEnvUrl = styled.span`
  font-family: monospace;
  font-size: ${({ theme }) => theme.fontSizes.sm};
`;

const StyledLoadRow = styled.div`
  display: flex;
  gap: 0.625rem;
  align-items: stretch;
`;

const StyledWorkflowIdInput = styled.input`
  flex: 1;
  font-size: ${({ theme }) => theme.fontSizes.md};
  height: 36px;
`;

const StyledCreateNewSlot = styled.div`
  margin-top: 1.25rem;
  padding-top: 1.25rem;
  border-top: 1px solid ${({ theme }) => theme.colors.borderSubtle};
`;

const StyledCreateNewButton = styled.button`
  width: 100%;
`;

const StyledErrorSlot = styled.div`
  margin-top: 1rem;
`;

export default {
  StyledShell,
  StyledMain,
  StyledContent,
  StyledHeaderBlock,
  StyledTitle,
  StyledSubtitle,
  StyledCard,
  StyledCardSection,
  StyledCardSectionWithDivider,
  StyledSectionTitle,
  StyledActiveEnvInfo,
  StyledActiveEnvName,
  StyledActiveEnvUrl,
  StyledLoadRow,
  StyledWorkflowIdInput,
  StyledCreateNewSlot,
  StyledCreateNewButton,
  StyledErrorSlot,
};
